import React from 'react';

import {
  Create,
  SimpleForm,
  TextInput,
  required,
  RecordContextProvider,
  ArrayField,
  Datagrid,
  TextField,
  useGetOne,
} from 'react-admin';

import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Typography,
  Box,
} from '@mui/material';

import { useFieldArray, useFormState } from 'react-hook-form';

import AddEntities from './components/AddEntities';
import { boldDataGridStyle } from '../../constants/style/datagridStyles';
import ReferenceEntityField from '../../customFields/ReferenceEntityField';
import Pagination from '../layout/Pagination';
import DeleteEntities from './components/DeleteEntities';
import ColoredScoreField from '../../customFields/ColoredScoreField';
import RiskClassField from '../../customFields/RiskClassField';
import EntityDisplayNameField from '../../customFields/EntityDisplayNameField';

const Entities = () => {
  const { append, fields, remove } = useFieldArray({
    name: 'entities',
    keyName: 'key',
    rules: {
      required: 'This is required',
      minLength: 1,
    },
  });

  const { errors } = useFormState();
  const errorMessage = errors.entities?.root?.message as string | undefined;

  return (
    <RecordContextProvider value={{ entities: fields }}>
      <Card variant="outlined">
        <CardHeader title="Entities" action={<AddEntities append={append} />} />
        <Divider />
        <ArrayField source="entities" perPage={10}>
          <Datagrid sx={boldDataGridStyle} bulkActionButtons={false}>
            <TextField source="type" />
            <ReferenceEntityField source="" label="Display name">
              <EntityDisplayNameField />
            </ReferenceEntityField>
            <ReferenceEntityField source="" linkType={false} label="Risk score">
              <ColoredScoreField source="riskScore" />
            </ReferenceEntityField>
            <ReferenceEntityField source="" linkType={false} label="Risk class">
              <RiskClassField source="riskScore" />
            </ReferenceEntityField>
            <DeleteEntities remove={remove} fields={fields} />
          </Datagrid>
          {errorMessage && (
            <Box paddingX={4} paddingBottom={4}>
              <Typography color="error">{errorMessage}</Typography>
            </Box>
          )}
          <Pagination disableEmptyText />
        </ArrayField>
      </Card>
    </RecordContextProvider>
  );
};

const PingCreate = ({
  caseId,
  resource,
  onSuccess,
  onError,
}: {
  caseId?: string;
  resource?: string;
  onSuccess?: () => void;
  onError?: (e: Error) => void;
}) => {
  const { data } = useGetOne('cases', { id: caseId }, { enabled: !!caseId });

  if (caseId && !data) return null;

  return (
    <Create
      resource={resource}
      mutationOptions={{
        onSuccess,
        onError,
      }}
    >
      <Card variant="outlined">
        <CardContent>
          <SimpleForm mode="all" defaultValues={{ caseId, entities: data.entities }} component={Box}>
            <Grid container spacing={4}>
              <Grid size={12}>
                <Entities />
              </Grid>
              <Grid size={12}>
                <Card variant="outlined">
                  <CardHeader title="Details" />
                  <Divider />
                  <CardContent>
                    <Grid container spacing={1}>
                      <Grid size={12}>
                        <Typography variant="label">Description of ping</Typography>
                      </Grid>
                      <Grid size={12}>
                        <TextInput fullWidth multiline minRows={3} source="description" validate={required()} />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </SimpleForm>
        </CardContent>
      </Card>
    </Create>
  );
};

export default PingCreate;
